<template>
  <div class="cards">
    <Card
      v-for="(card, index) in cards"
      :key="`card${card.item_id}`"
      :card="card"
      :is-current="index === 0"
      :index="index"
      :current-index="currentIndex"
      @cardAccepted="$emit('cardAccepted');"
      @cardRejected="$emit('cardRejected');"
      @cardSkipped="$emit('cardSkipped');"
      @hideCard="$emit('hideCard');"
    />
  </div>
</template>

<script>
import Card from "@/components/Card";

export default {
  components: {
    Card
  },
  props: {
    cards: {
      type: Array,
      required: true
    },
    currentIndex: {
      type: Number
    }
  }
};
</script>

<style lang="scss" scoped>
.cards {
  position: relative;
  display: flex;
  margin-left: auto;
  margin-right: auto;
  width: 320px;
  height: 420px;
}
</style>
